import React from "react";
import { FormatDateWTime } from "../../utils/FormatData";
import { Badge, Col, Row } from "react-bootstrap";
// import AdvanceTableFooter from "../../components/AdvanceTableFooter";
// import AdvanceTablePagination from "../../components/AdvanceTablePagination";
// import AdvanceTable from "../../components/AdvanceTable";
// import AdvanceTableWrapper from "../../components/AdvanceTableWrapper";
// import BtnExportToExcell from "../../utils/BtnExportToExcell";
import PropTypes from "prop-types";
import { Table } from '../../components/ui/Table';
// Icons
//import * as AiIcons from "react-icons/ai";

const columns = [
  {
    accessor: "customer",
    Header: "Cliente",
  },
  {
    accessor: "partner",
    Header: "Partner",
  },
  {
    accessor: "msisdn",
    Header: "Telefono",
    Cell: (rowData) => {
      let rowInfo = rowData.row.original;
      return <>{rowInfo.msisdn}</>;
    },
  },
  {
    accessor: "create",
    Header: "Fecha",
    Cell: (rowData) => {
      let rowInfo = rowData.row.original;
      return (
        <>
          <Row>
            <Col className="DateDetails">{FormatDateWTime(rowInfo.create)}</Col>
          </Row>
        </>
      );
    },
  },
  {
    accessor: "carrier",
    Header: "Carrier",
  },
  {
    accessor: "shortCode",
    Header: "Marcacion",
  },
  {
    accessor: "tipo",
    Header: "Tipo",
  },
  {
    accessor: "message",
    Header: "Detalles",
    Cell: (rowData) => {
      let rowInfo = rowData.row.original;
      return (
        <>
          <Row>
            <Col style={{ maxWidth: "600px" }}>{rowInfo.message}</Col>
          </Row>
        </>
      );
    },
  },

  {
    accessor: "origen",
    Header: "Origen",
    Cell: (rowData) => {
      let rowInfo = rowData.row.original;
      return (
        <>
          <Row>
            <Col className="DateDetails">
              <b>{rowInfo.origen}</b>{" "}
              {rowInfo.campaign ? " | " + rowInfo.campaign : ""}
            </Col>{" "}
          </Row>
        </>
      );
    },
  },

  {
    accessor: "status",
    Header: "Status",
    Cell: (rowData) => {
      let rowInfo = rowData.row.original;
      return (
        <>
          <div className="right">
            <Badge
              bg={
                rowInfo.status == "ENTREGADO"
                  ? "success"
                  : rowInfo.status == "PROGRAMADO"
                  ? "warning"
                  : "danger"
              }
            >
              {rowInfo.status}
            </Badge>
          </div>
        </>
      );
    },
  },
];
const AdminReportSmsList = ({ listMessages, periodStr, isLoading }) => {
  return (
    <>
      {/* {listMessages && (
        <AdvanceTableWrapper
          columns={columns}
          data={listMessages}
          sortable
          pagination
          perPage={10}
        >
          <Row>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="DbDetails2">
                <Stack direction="horizontal" gap={2}>
                  <AiIcons.AiOutlineCalendar />
                  <div className="ms-auto">
                    <p>{periodStr}</p>
                  </div>
                </Stack>
                <div className="details">Rango de fechas</div>
              </div>
            </Col>
          </Row>
          <div>
            <div style={{ textAlign: "left" }}>
              <h4>Lista de Mensajes</h4>
            </div>
            <div style={{ textAlign: "right" }}>
              <BtnExportToExcell
                dataReport={listMessages}
                fileName="SMS_Report"
              ></BtnExportToExcell>
            </div>
          </div>

          <AdvanceTable
            table
            headerClassName="bg-200 text-900 text-nowrap align-middle"
            rowClassName="align-middle white-space-nowrap"
            tableProps={{
              size: "sm",
              striped: true,
              className: "fs--1 mb-0 overflow-hidden",
            }}
          />
          <AdvanceTablePagination table />
          <AdvanceTableFooter
            rowCount={listMessages.length}
            table
            rowInfo
            navButtons
            rowsPerPageSelection
            pageSize={10}
          />
        </AdvanceTableWrapper>
      )} */}
      <div className="bg-white rounded-lg px-4 py-2 my-2">
        <div className="flex justify-between">
          <div className="text-lg font-semibold">Reporte de SMS</div>
          <div className="flex items-center bg-blue-100 rounded-lg px-2 py-1">
            <span className="material-symbols-outlined text-blue-700">
              schedule
            </span>

            <span className="mx-2 font-semibold text-md text-blue-700">
              {periodStr}
            </span>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg px-4 py-2">
        <Table
          data={listMessages}
          columns={columns}
          loading={isLoading}
          config={{
            search: true,
            footer: true,
            pageSize: 10,
            perPage: 10,
            export: true,
          }}
        />
      </div>
    </>
  );
};
AdminReportSmsList.propTypes = {
  listMessages: PropTypes.array.isRequired,
  periodStr: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
};
export default AdminReportSmsList;
